/* Página de Favoritos — renderiza os cards salvos e reage ao desfavoritar.
   Handles vêm do jm-wishlist.js; cada card real é buscado via Section
   Rendering (jm-vitrine-card-render) em paralelo, preservando a ordem. */
(function () {
  var root = document.querySelector('[data-jm-fav]');
  if (!root) return;

  var grid = root.querySelector('[data-jm-fav-grid]');
  var skeleton = root.querySelector('[data-jm-fav-skeleton]');
  var empty = root.querySelector('[data-jm-fav-empty]');
  var count = root.querySelector('[data-jm-fav-count]');

  function setCount(n) {
    if (!count) return;
    count.hidden = n === 0;
    count.textContent = n === 1 ? '1 produto salvo' : n + ' produtos salvos';
  }

  function showEmpty() {
    if (skeleton) skeleton.hidden = true;
    grid.hidden = true;
    empty.hidden = false;
    setCount(0);
  }

  function fetchCard(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '?section_id=jm-vitrine-card-render')
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (chunk) {
        if (!chunk) return '';
        var doc = new DOMParser().parseFromString(chunk, 'text/html');
        var card = doc.querySelector('jm-vitrine-card');
        return card ? card.outerHTML : '';
      })
      .catch(function () { return ''; });
  }

  function render() {
    var handles = window.JMWishlist ? window.JMWishlist.read() : [];
    if (!handles.length) { showEmpty(); return; }

    Promise.all(handles.map(fetchCard)).then(function (chunks) {
      var html = chunks.filter(Boolean).join('');
      if (skeleton) skeleton.hidden = true;
      if (!html) { showEmpty(); return; }
      grid.innerHTML = html;
      grid.hidden = false;
      empty.hidden = true;
      setCount(grid.querySelectorAll('jm-vitrine-card').length);
    });
  }

  // desfavoritou (aqui ou em outra aba): remove o card com animação
  document.addEventListener('jm:wishlist:change', function (e) {
    if (grid.hidden) return;
    var keep = new Set(e.detail && e.detail.handles ? e.detail.handles : []);
    var cards = Array.prototype.slice.call(grid.querySelectorAll('jm-vitrine-card'));
    var leaving = cards.filter(function (c) { return !keep.has(c.dataset.productHandle); });
    if (!leaving.length) {
      setCount(cards.length);
      return;
    }
    leaving.forEach(function (c) { c.classList.add('is-leaving'); });
    window.setTimeout(function () {
      leaving.forEach(function (c) { c.remove(); });
      var rest = grid.querySelectorAll('jm-vitrine-card').length;
      setCount(rest);
      if (!rest) showEmpty();
    }, 330);
  });

  render();
})();
